import { SafeUrl } from '@angular/platform-browser';
import { createAction, props } from '@ngrx/store';
import { Dashboard } from '../../../models/dashboard.model';

// Page Actions
export const loadDashboardDataSuccess = createAction(
  '[Dashboard] Load Dashboard Data Success',
  props<{ dashboard: Dashboard | null }>()
);
export const loadDashboardDataFailure = createAction(
  '[Dashboard] Load Dashboard Data Failure',
  props<{ error: any }>()
);

export const resetAccountsToInitialState = createAction(
  '[Home Component] Reset Accounts To Initial State'
);

export const removeAccountsFromStore = createAction(
  '[Home Component] Remove Accounts From State'
);

export const reduceUnreadMessages = createAction(
  '[Home Component] Update Total Unread Messages',
  props<{ unreadMessages: number }>()
);

export const loadProfileImageSuccess = createAction(
  '[Layout Component] Load Profile Image Success',
  props<{ profileImg: string | SafeUrl | null }>()
);

// API Actions
export const loadDashboardApi = createAction(
  '[Layout Component API] Load Dashboard Data'
);

export const loadProfileImageApi = createAction(
  '[Layout Component API] Load Profile Image'
);

export const refreshDashboardApi = createAction('[Dashboard] Refresh Balance');
